import React from 'react';
import qs from 'qs';
import Redirect from './redirect';

export const Search = ({ location: { search } }) => {
  const { search: query } = qs.parse(search || '', { ignoreQueryPrefix: true });
  const [searchInputValue] = React.useState(query || '');

  const solutionsDashboardURL = process.env.REACT_APP_SOLUTIONS_DASHBOARD_URL || 'https://manage.rackspace.com/dashboard';
  let url = `${solutionsDashboardURL}/racker/search?filter-by=type:MANAGED_GCP`;

  if (searchInputValue) {
    url = `${solutionsDashboardURL}/racker/customers/${searchInputValue}?types=MANAGED_GCP&status=Active`;
  }
  return (<Redirect url={url} />);
};
